import { uuid } from 'vue-uuid';

export default class Message {
  constructor(title, type = 'default', close = true) {
    this.uid = uuid.v1();
    this.title = title;
    this.close = close;
    this.type = type;
  }

  success() {
    this.type = 'success';
    return this;
  }

  error() {
    this.type = 'error';
    return this;
  }

  dontClose() {
    this.close = false;
    return this;
  }
}
